import styled from 'styled-components'
import { BP } from 'resources/constants'
import dripIcon from 'resources/images/drip.png'
import dribbleIcon from 'resources/images/dribble.png'
import gushIcon from 'resources/images/gush.png'
import heavyFlowIcon from 'resources/images/heavy-flow.png'
import floodingIcon from 'resources/images/flooding.png'
import AngleRightSvg from 'resources/svg/icons/angle-right.svg'

export const Wrapper = styled.li<any>`
  &,
  li {
    list-style: none;
    cursor: pointer;

    @media (max-width: ${BP.lg.min}) {
      display: flex;
      align-items: center;
      justify-content: space-between;
      ${props => props.isParent && `
        &::after {
          content: '';
          width: 15px;
          height: 15px;
          background: url(${AngleRightSvg}) no-repeat center;
          background-size: 6px;
          display: inline-block;
          margin-left: auto;
        }
      `}
    }
  }

  .back {
    display: none;
    cursor: pointer;

    @media (max-width: ${BP.lg.min}) {
      display: block;
    }
  }

  &.has-icon,
  &.with-image,
  .has-icon,
  .with-image {
    padding: 7px 20px;
  }

  &.with-image,
  .with-image {
    height: 36px;
  }

  .menu_icon {
    display: inline-block;
    width: 22px;
    height: 26px;
    margin-right: 15px;
    background-position: center center;
    background-repeat: no-repeat;
  }

  .icon {
    &-drip {
      background-image: url(${dripIcon});
    }

    &-dribble {
      background-image: url(${dribbleIcon});
    }

    &-gush {
      background-image: url(${gushIcon});
    }

    &-heavy-flow {
      background-image: url(${heavyFlowIcon});
    }

    &-flooding {
      background-image: url(${floodingIcon});
    }
  }
`

export const Item = styled.div<any>`
  position: relative;
  cursor: pointer;

  & > p {
    padding: 10px;
    margin: 0;
  }

  &:hover {
    box-shadow: ${props => props.theme.palette.general.boxShadow};

    > p span {
      color: ${props => props.theme.palette.primary.alphaDark};
    }

    > div {
      display: block;
    }
  }

  .has-children {
    &:hover {
      > a {
        color: ${props => props.theme.palette.primary.alphaDark};
      }
    }
  }

  .children-level-1 {
    li {
      > a {
        display: flex;
        align-items: center;
        justify-content: space-between;
        white-space: nowrap;
      }

      &.has-children {
        > a {
          &::after {
            content: '';
            width: 15px;
            height: 15px;
            background: url(${AngleRightSvg}) no-repeat center;
            background-size: 6px;
            display: inline-block;
            margin-left: auto;
          }
        }
      }
    }
  }

  > div {
    width: 600px;
    display: none;
    position: absolute;
    z-index: 2;
    background: transparent;
    transition: all ease-in-out 0.3s;

    ul {
      flex-direction: column;
      width: 215px;
      padding: 10px 0;
      background: ${props => props.theme.palette.general.light};
      box-shadow: ${props => props.theme.palette.general.boxShadow};
      ${props => props.isLivBrite && `
        min-height: 300px;
      `}

      &.inspiration {
        width: 300px;
      }

      li {
        padding: 10px 20px;

        a {
          padding: 5px;
          display: flex;
          align-items: center;
        }
      }

      .has-children {
        &:hover {
          > .children {
            display: flex;
          }
        }

        > div {
          background: ${props => props.theme.palette.general.light};
        }

        .children {
          position: absolute;
          display: none;
          height: 100%;

          &-level-2,
          &-level-3 {
            top: 0;
            left: 210px;
          }

          > ul {
            box-shadow: 3px 3px 6px 0 rgba(0, 0, 0, 0.16);

            &::before {
              content: '';
              width: 1px;
              height: auto;
              background: ${props => props.theme.palette.general.strong};
              display: block;
              position: absolute;
              left: 0;
              z-index: 9;
              top: 15px;
              bottom: 15px;
              opacity: 0.3;
            }
          }

          &-level-3 {
            box-shadow: 3px 3px 6px 0 rgba(0, 0, 0, 0.16);

            > div {
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 5px;
              width: 210px;

              img {
                max-height: 298px;
                max-width: 100%;
              }
            }

            > ul {
              box-shadow: none;
            }
          }
        }
      }
    }
  }
`
